import React, { Fragment } from 'react'
import styles from './form-holder.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const FormHolder = ({ classes, children, error, equalPadding }) => (
  <div
    className={classNames(classes.container, {
      [classes.equalPadding]: equalPadding
    })}>
    <Fragment>
      {children}
      {error && <div className={classes.error}>{error}</div>}
    </Fragment>
  </div>
)

export default injectSheet(styles)(FormHolder)
